import React from "react";
import { withRouter, Link, useParams, useLocation } from "react-router-dom";
import { Navigation } from "./navigation";
import { Container, Card, Row, Col, Button, Stack, Form, Badge } from "react-bootstrap";
import moment from "moment";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBullhorn, faCube, faTrophy, faPaperPlane, faCalendarDays, faMedal, faFire, faCartShopping, faUsers, faChartLine, faCoins, faCircleCheck, faTriangleExclamation, faCircleInfo, faCircleUser } from '@fortawesome/free-solid-svg-icons';
import ReactPaginate from 'react-paginate';
import firebaseConfig from "../firebaseConfig";
import { initializeApp } from "firebase/app";
import { getStorage, ref, uploadBytes, deleteObject } from "firebase/storage";
import AnimateHeight from 'react-animate-height';
import FAQWidget from "./faqWidget";

initializeApp(firebaseConfig);


export function Dashboard() {
    const { state } = useLocation();
    const [self, setSelf] = React.useState(state.user);
    const [user, setUser] = React.useState(state.user);
    const [prizes, setPrizes] = React.useState([]);
    const [editPrize, setEditPrize] = React.useState({});
    const [userData, setData] = React.useState([]);
    const token = localStorage.getItem("token");
    const [toggle, setToggle] = React.useState(false);
    const [userIndex, setUserIndex] = React.useState();
    const [coins, setCoins] = React.useState(0);
    const [budget, setBudget] = React.useState(user.budgetAmount);
    const [height, setHeight] = React.useState(0);
    const [transHeight, setTransHeight] = React.useState(0);
    const [historyHeight, setHistoryHeight] = React.useState(0);
    const [earnHeight, setEarnHeight] = React.useState(0);
    const [disable, setDisable] = React.useState(false);
    const [selectedFile, setSelectedFile] = React.useState(null);
    const [imagePreview, setImagePreview] = React.useState(null);
    const [announcementsData, setAnnouncementsData] = React.useState([]);
    const [earnTasks, setEarnTasks] = React.useState([]);
    const [earnForm, setEarnForm] = React.useState({ title: "", coins: "", scope: "all", assignedUserId: "", expiresOn: "" });
    const [earnSaving, setEarnSaving] = React.useState(false);
    const [dashboardView, setDashboardView] = React.useState('operations');
    const [turnoverSummary, setTurnoverSummary] = React.useState(null);
    const [openInsightCard, setOpenInsightCard] = React.useState(null);
    const [resendingPoster, setResendingPoster] = React.useState(false);
    const [showPosterEmailModal, setShowPosterEmailModal] = React.useState(false);
    const [posterEmail, setPosterEmail] = React.useState('');
    const [showProfilePanel, setShowProfilePanel] = React.useState(false);
    const [isClosingProfilePanel, setIsClosingProfilePanel] = React.useState(false);
    const [profileSaving, setProfileSaving] = React.useState(false);
    const [profileForm, setProfileForm] = React.useState({ firstname: '', lastname: '', phone: '', organization: '' });
    const history = user.history
    const billingStatus = String(user?.billingStatus || '').toLowerCase();
    const billingBlocked = Boolean(user?.admin && billingStatus !== 'active' && billingStatus !== 'trialing');

    React.useEffect(() => {
        setProfileForm({
            firstname: user?.firstname || '',
            lastname: user?.lastname || '',
            phone: user?.phone || '',
            organization: user?.organization || '',
        });
    }, [user?.firstname, user?.lastname, user?.phone, user?.organization]);

    React.useEffect(() => {
        const closeInsightOnOutsideClick = (event) => {
            if (event?.target?.closest('.metric-insight-trigger') || event?.target?.closest('.metric-insight-popover')) return;
            setOpenInsightCard(null);
        };

        document.addEventListener('mousedown', closeInsightOnOutsideClick);
        document.addEventListener('touchstart', closeInsightOnOutsideClick);

        return () => {
            document.removeEventListener('mousedown', closeInsightOnOutsideClick);
            document.removeEventListener('touchstart', closeInsightOnOutsideClick);
        };
    }, []);

    // * Function to sort alphabetically an array of objects by some specific key.
    function dynamicSort(property) {
        var sortOrder = 1;

        if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
        }

        return function (a, b) {
            if (sortOrder == -1) {
                return b[property].localeCompare(a[property]);
            } else {
                return a[property].localeCompare(b[property]);
            }
        }
    }
    let sorted = prizes.sort(dynamicSort("title"));


    const userHistory = userData.filter(user => user.history).map(user => user.history).reduce((a, b) => a.concat(b), []).filter(user => user.action[0] === "P");
    //show by date
    const sortedHistory = history.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return new Date(b.date) - new Date(a.date);
    });
    console.log("sortedHistory", sortedHistory.length);

    function coin(cost) {
        if (cost !== 1) {
            return (
                `${cost} Crew Coins`

            )
        } else {
            return (
                `${cost} Crew Coin`
            )
        }
    }
    function buttonToggle(height) {
        if (height === "auto" || height === true) {
            return "-"
        } else {
            return "+"
        }
    }

    function isTaskExpired(task) {
        if (!task?.expiresAt) return false;
        const d = new Date(task.expiresAt);
        return !Number.isNaN(d.getTime()) && d.getTime() < Date.now();
    }

    function activeEarnTasksForCurrentUser() {
        return (earnTasks || []).filter((task) => {
            if (!task?.active) return false;
            if (user.admin) return true;
            if (task.scope === 'all') return true;
            const assigned = Array.isArray(task.assignedUserIds) ? task.assignedUserIds.map(String) : [];
            return assigned.includes(String(user._id));
        });
    }

    function buildBadgeSummary() {
        const historyItems = Array.isArray(user?.history) ? user.history : [];
        const now = Date.now();
        const thirtyDaysAgo = now - (30 * 24 * 60 * 60 * 1000);
        const sevenDaysAgo = now - (7 * 24 * 60 * 60 * 1000);

        const earnedCoins = historyItems
            .filter((i) => String(i?.action || '').toLowerCase().includes('received'))
            .reduce((s, i) => s + (Number(i?.amount) || 0), 0);

        const purchases = historyItems
            .filter((i) => String(i?.action || '').toLowerCase().includes('purchased'))
            .length;

        const activeDays = new Set(
            historyItems
                .filter((i) => {
                    const d = new Date(i?.date || 0);
                    return !Number.isNaN(d.getTime()) && d.getTime() >= thirtyDaysAgo;
                })
                .map((i) => new Date(i.date).toISOString().slice(0, 10))
        ).size;

        const sentToCrew7DayCount = historyItems
            .filter((i) => {
                const isSent = String(i?.action || '').toLowerCase().includes('sent');
                const d = new Date(i?.date || 0);
                return isSent && !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
            })
            .length;

        const announcements7DayCount = (announcementsData || []).filter((item) => {
            const d = new Date(item?.createdAt || item?.updatedAt || 0);
            return !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
        }).length;

        const storeItemsRecentCount = (prizes || []).filter((item) => {
            const d = new Date(item?.createdAt || item?.updatedAt || 0);
            return !Number.isNaN(d.getTime()) && d.getTime() >= thirtyDaysAgo;
        }).length;

        const challenges7DayCount = (earnTasks || []).filter((item) => {
            const d = new Date(item?.createdAt || item?.updatedAt || 0);
            return !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
        }).length;

        const badges = user.admin
            ? [
                { label: 'Announcer', icon: faBullhorn, unlocked: announcements7DayCount >= 1 },
                { label: 'Store Builder', icon: faCube, unlocked: storeItemsRecentCount >= 1 },
                { label: 'Challenge Creator', icon: faTrophy, unlocked: challenges7DayCount >= 1 },
                { label: 'Crew Sponsor', icon: faPaperPlane, unlocked: sentToCrew7DayCount >= 1 },
                { label: 'Consistent Activity', icon: faCalendarDays, unlocked: activeDays >= 7 },
            ]
            : [
                { label: 'Coin Collector I', icon: faMedal, unlocked: earnedCoins >= 100 },
                { label: 'Coin Collector II', icon: faTrophy, unlocked: earnedCoins >= 500 },
                { label: 'Consistent Crew', icon: faFire, unlocked: activeDays >= 7 },
                { label: 'First Redeemer', icon: faCartShopping, unlocked: purchases >= 1 },
            ];

        const unlockedCount = badges.filter((b) => b.unlocked).length;
        const totalBadges = badges.length || 1;
        const completionPercent = Math.round((unlockedCount / totalBadges) * 100);
        const level = Math.max(1, Math.min(5, Math.ceil((completionPercent || 1) / 20)));

        return {
            badges,
            unlockedCount,
            completionPercent,
            level,
        };
    }


    function buildAnalyticsSnapshot() {
        const now = Date.now();
        const sevenDaysAgo = now - (7 * 24 * 60 * 60 * 1000);
        const fourteenDaysAgo = now - (14 * 24 * 60 * 60 * 1000);
        const thirtyDaysAgo = now - (30 * 24 * 60 * 60 * 1000);
        const nonAdminUsers = (userData || []).filter((u) => !u?.admin);
        const totalEmployees = nonAdminUsers.length;

        const activeUsers = nonAdminUsers.filter((u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            return events.some((entry) => {
                const action = String(entry?.action || '').toLowerCase();
                const d = new Date(entry?.date || 0);
                const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
                const engagementAction = action.includes('received') || action.includes('purchased');
                return inWindow && engagementAction;
            });
        });

        const activeEmployees = activeUsers.length;

        const engagementPointsByUser = nonAdminUsers.map((u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            const eventsInWindow = events.filter((entry) => {
                const d = new Date(entry?.date || 0);
                return !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
            });

            const activeDays = new Set(eventsInWindow.map((entry) => new Date(entry?.date).toISOString().slice(0, 10))).size;
            const receivedCount = eventsInWindow.filter((entry) => String(entry?.action || '').toLowerCase().includes('received')).length;
            const purchasedCount = eventsInWindow.filter((entry) => {
                const action = String(entry?.action || '').toLowerCase();
                return action.includes('purchased') || action.includes('redeemed');
            }).length;

            const rawPoints = activeDays + (receivedCount * 3) + (purchasedCount * 4);
            const normalizedPercent = Math.min(100, Math.round((rawPoints / 12) * 100));
            return normalizedPercent;
        });

        const engagementScore = engagementPointsByUser.length
            ? Math.round(engagementPointsByUser.reduce((s, p) => s + p, 0) / engagementPointsByUser.length)
            : 0;

        const coinsIssued7d = nonAdminUsers.reduce((sum, u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            const subtotal = events.reduce((s, entry) => {
                const action = String(entry?.action || '').toLowerCase();
                const d = new Date(entry?.date || 0);
                const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
                if (!inWindow || !action.includes('received')) return s;
                return s + (Number(entry?.amount) || 0);
            }, 0);
            return sum + subtotal;
        }, 0);

        const challengesCompleted7d = (earnTasks || []).reduce((sum, task) => {
            const completedBy = Array.isArray(task?.completedBy) ? task.completedBy : [];
            const count = completedBy.filter((entry) => {
                const d = new Date(entry?.completedAt || 0);
                return !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
            }).length;
            return sum + count;
        }, 0);

        const announcementsCreated7d = (announcementsData || []).filter((item) => {
            const d = new Date(item?.createdAt || item?.updatedAt || 0);
            return !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
        }).length;

        const coinsInCirculation = nonAdminUsers.reduce((sum, u) => sum + (Number(u?.balance) || 0), 0);

        const purchasesLast30d = nonAdminUsers.reduce((sum, u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            const count = events.filter((entry) => {
                const action = String(entry?.action || '').toLowerCase();
                const d = new Date(entry?.date || 0);
                const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= thirtyDaysAgo;
                return inWindow && (action.includes('purchased') || action.includes('redeemed'));
            }).length;
            return sum + count;
        }, 0);

        const circulationDelta30d = nonAdminUsers.reduce((sum, u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            const userDelta = events.reduce((s, entry) => {
                const action = String(entry?.action || '').toLowerCase();
                const d = new Date(entry?.date || 0);
                const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= thirtyDaysAgo;
                if (!inWindow) return s;

                const amount = Number(entry?.amount) || 0;
                if (action.includes('received') || action.includes('added')) return s + amount;
                if (action.includes('purchased') || action.includes('redeemed') || action.includes('spent')) return s - amount;
                return s;
            }, 0);
            return sum + userDelta;
        }, 0);

        const usersNeedingAttention = nonAdminUsers
            .map((u) => {
                const events = Array.isArray(u?.history) ? u.history : [];
                const engaged = events.some((entry) => {
                    const action = String(entry?.action || '').toLowerCase();
                    const d = new Date(entry?.date || 0);
                    const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= sevenDaysAgo;
                    return inWindow && (action.includes('received') || action.includes('purchased'));
                });

                const lastEvent = [...events]
                    .sort((a, b) => new Date(b?.date || 0) - new Date(a?.date || 0))[0];

                return {
                    id: u?._id,
                    name: `${u?.firstname || ''} ${u?.lastname || ''}`.trim() || u?.username || 'Crew Member',
                    engaged,
                    lastActivityAt: lastEvent?.date || null,
                };
            })
            .filter((u) => !u.engaged)
            .slice(0, 6);

        const activeEmployeesPrev = nonAdminUsers.filter((u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            return events.some((entry) => {
                const action = String(entry?.action || '').toLowerCase();
                const d = new Date(entry?.date || 0);
                const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= fourteenDaysAgo && d.getTime() < sevenDaysAgo;
                return inWindow && (action.includes('received') || action.includes('purchased'));
            });
        }).length;

        const engagementPointsByUserPrev = nonAdminUsers.map((u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            const eventsInWindow = events.filter((entry) => {
                const d = new Date(entry?.date || 0);
                return !Number.isNaN(d.getTime()) && d.getTime() >= fourteenDaysAgo && d.getTime() < sevenDaysAgo;
            });

            const activeDays = new Set(eventsInWindow.map((entry) => new Date(entry?.date).toISOString().slice(0, 10))).size;
            const receivedCount = eventsInWindow.filter((entry) => String(entry?.action || '').toLowerCase().includes('received')).length;
            const purchasedCount = eventsInWindow.filter((entry) => {
                const action = String(entry?.action || '').toLowerCase();
                return action.includes('purchased') || action.includes('redeemed');
            }).length;

            const rawPoints = activeDays + (receivedCount * 3) + (purchasedCount * 4);
            return Math.min(100, Math.round((rawPoints / 12) * 100));
        });

        const engagementScorePrev = engagementPointsByUserPrev.length
            ? Math.round(engagementPointsByUserPrev.reduce((s, p) => s + p, 0) / engagementPointsByUserPrev.length)
            : 0;

        const coinsIssuedPrev7d = nonAdminUsers.reduce((sum, u) => {
            const events = Array.isArray(u?.history) ? u.history : [];
            const subtotal = events.reduce((s, entry) => {
                const action = String(entry?.action || '').toLowerCase();
                const d = new Date(entry?.date || 0);
                const inWindow = !Number.isNaN(d.getTime()) && d.getTime() >= fourteenDaysAgo && d.getTime() < sevenDaysAgo;
                if (!inWindow || !action.includes('received')) return s;
                return s + (Number(entry?.amount) || 0);
            }, 0);
            return sum + subtotal;
        }, 0);

        const challengesCompletedPrev7d = (earnTasks || []).reduce((sum, task) => {
            const completedBy = Array.isArray(task?.completedBy) ? task.completedBy : [];
            const count = completedBy.filter((entry) => {
                const d = new Date(entry?.completedAt || 0);
                return !Number.isNaN(d.getTime()) && d.getTime() >= fourteenDaysAgo && d.getTime() < sevenDaysAgo;
            }).length;
            return sum + count;
        }, 0);

        const announcementsCreatedPrev7d = (announcementsData || []).filter((item) => {
            const d = new Date(item?.createdAt || item?.updatedAt || 0);
            return !Number.isNaN(d.getTime()) && d.getTime() >= fourteenDaysAgo && d.getTime() < sevenDaysAgo;
        }).length;

        return {
            engagementScore,
            activeEmployees,
            totalEmployees,
            coinsIssued7d,
            coinsInCirculation,
            purchasesLast30d,
            challengesCompleted7d,
            announcementsCreated7d,
            usersNeedingAttention,
            trends: {
                engagementScore: engagementScore - engagementScorePrev,
                activeEmployees: activeEmployees - activeEmployeesPrev,
                coinsIssued7d: coinsIssued7d - coinsIssuedPrev7d,
                challengesCompleted7d: challengesCompleted7d - challengesCompletedPrev7d,
                announcementsCreated7d: announcementsCreated7d - announcementsCreatedPrev7d,
                coinsInCirculation30d: circulationDelta30d,
            },
        };
    }

    function quickAddCoins(id) {
        if (!requireActiveBilling()) return;
        let text = `Are you sure you want to add ${coin(coins)} to your account?`;;
        if (window.confirm(text)) {
            fetch(`https://crewcoin.herokuapp.com/crewuser/quickadd/${id}`, {
                method: "PUT",
                headers: {
                    //bearer token
                    authorization: `bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    mode: "cors"
                },
                body: JSON.stringify({
                    "coinincrease": coins,
                    "history": {
                        "date": new Date(),
                        "action": "Added",
                        "amount": coins,
                        "comments": "Quick Add",
                        "who": "from Crew-Coin.com"
                    },
                }),
            })

                .then(res => res.json())
                .then(res => {
                    if (res.success) {
                        setUser(res.crewuser);
                        setCoins(0);
                        alert(`${coin(coins)} Crew Coins added to account!`);
                        setDisable(false);
                        window.location.reload();
                    } else {
                        alert("Please check internet connection!")
                        setDisable(false);
                    }
                })
                .catch(err => {
                    alert("Error")
                }
                );

        }

    }
    function addBudget(id) {
        if (!requireActiveBilling()) return;

        let currentBudget = () => {
            if (budget > 0) {
                return (
                    true
                )
            } else
                return (
                    false
                )
        }

        fetch(`https://crewcoin.herokuapp.com/crewuser/addbudget/${id}`, {
            method: "PUT",
            headers: {
                //bearer token
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
            body: JSON.stringify({
                budgetAmount: budget,
                budget: currentBudget(),
                "history": {
                    "date": new Date(),
                    "action": "Added monthly schedule of",
                    "amount": budget,
                    "comments": "Set Monthly Budget",
                    "who": "from Crew-Coin.com"
                },
            }),
        })

            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    setUser(res.crewuser);
                    setSelf(res.crewuser);
                    setBudget(res.crewuser.budgetAmount)
                    alert(`Budget of ${coin(budget)} added to account!`);
                    setDisable(false);
                    window.location.reload();
                } else {
                    alert("Please check internet connection!")
                    setDisable(false);
                }
            })
            .catch(err => {
                alert("Error")
            }
            );
    }


    function Items({ currentItems }) {

        if (sortedHistory && sortedHistory.length > 0) {
            return (
                <>
                    {currentItems &&
                        currentItems.map((item, i) => (
                            <div key={i} className="row text-center px-5" >
                                <div className="border col-xs-12 my-2 col-xs-12 mb-2 ms-auto" key={i}>
                                    <Stack className="mx-auto" >
                                        <p><strong>{`${item.action} ${coin(item.amount)} ${item.who}`}</strong></p>
                                        <p>{`Comments: "${item.comments}"`}</p>
                                        <p><strong>{moment(item.date).format("MM/DD/YYYY")}</strong></p>
                                    </Stack>
                                </div>
                            </div>
                        ))}
                </>
            )
        } else {
            return (
                <div className="row text-center px-5" >
                    <div className="border mt-5 col-xs-8 col-xs-8 col-xs-offset-2 mb-2 ms-auto">
                        <Stack className="mx-auto" >
                            <p><i>No transactions yet</i></p>
                        </Stack>
                    </div>
                </div>
            )
        }
    }
    function PaginatedItems({ itemsPerPage }) {
        // We start with an empty list of items.
        let items = sortedHistory;
        const [currentItems, setCurrentItems] = React.useState(null);
        const [pageCount, setPageCount] = React.useState(0);
        // Here we use item offsets; we could also use page offsets
        // following the API or data you're working with.
        const [itemOffset, setItemOffset] = React.useState(0);

        React.useEffect(() => {
            // Fetch items from another resources.
            const endOffset = itemOffset + itemsPerPage;
            console.log(`Loading items from ${itemOffset} to ${endOffset}`);
            setCurrentItems(items.slice(itemOffset, endOffset));
            setPageCount(Math.ceil(items.length / itemsPerPage));
        }, [itemOffset, itemsPerPage]);

        // Invoke when user click to request another page.
        const handlePageClick = (event) => {
            const newOffset = (event.selected * itemsPerPage) % items.length;
            console.log(
                `User requested page number ${event.selected}, which is offset ${newOffset}`
            );
            setItemOffset(newOffset);
        };

        return (
            <>
                <Items currentItems={currentItems} />
                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={10}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    itemsPerPage={itemsPerPage}
                />
            </>
        );
    }

    function purchaseHistory() {

        function findUserByEmail(email) {
            const userObject = userData.find(user => user.username === email)
            return (userObject.firstname + " " + userObject.lastname)

        }
        const sortedHistory = userHistory.sort(function (a, b) {
            return new Date(b.date) - new Date(a.date);
        });
        if (userHistory && userHistory.length > 0) {
            return (
                sortedHistory.map((item, i) => {
                    return (

                        <div key={i} className="row text-center px-5" >
                            <div className="border col-xs-12 col-sm-12 mb-2 ms-auto" key={i}>
                                <Stack className="mx-auto" >
                                    <p><strong>{`${findUserByEmail(item.userEmail)}`}</strong></p>
                                    <p className="marginSmall">{item.action} {coin(item.amount)}</p>
                                    <p><strong>{moment(item.date).format("MM/DD/YYYY")}</strong></p>
                                </Stack>
                            </div>
                        </div>

                    )
                }))
        } else {
            return (
                <div className="row text-center px-5" >
                    <div className="border mt-5 col-xs-8 col-sm-8 col-sm-offset-2 mb-2 ms-auto">
                        <Stack className="mx-auto" >
                            <p><i>No purchases yet</i></p>
                        </Stack>
                    </div>
                </div>
            )
        }
    }
    function setAdmin(user, admin) {
        if (!requireActiveBilling()) return;
        let text = `Are you sure you want to change admin priveleges?`;
        let privelege = admin;
        if (window.confirm(text)) {
            fetch(`https://crewcoin.herokuapp.com/crewuser/changeadmin/${user}`, {
                method: "PUT",
                headers: {
                    //bearer token
                    authorization: `bearer ${token}`,
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    mode: "cors"
                },
                body: JSON.stringify({
                    "admin": privelege,
                }),
            })

                .then(res => res.json())
                .then(res => {
                    if (res.success) {
                        alert(`Admin status changed!`);
                        window.location.reload();
                    } else {
                        alert("Please check internet connection!")
                    }
                })
                .catch(err => {
                    alert("Error")
                }
                );
        }

    }

    function deleteUser(id, user) {
        if (!requireActiveBilling()) return;
        let text = `Are you sure you want to delete ${user}? This action cannot be undone!`;
        if (window.confirm(text)) {
            fetch(`https://crewcoin.herokuapp.com/crewuser/${id}`, {
                method: "DELETE",
                headers: {
                    authorization: `bearer ${token}`,
                    credentials: "same-origin",
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    mode: "cors"
                }
            })
                .then(res => res.json())
                .then(res => {
                    if (res.success) {

                        alert(
                            `${res.status}`
                        );
                    }
                })
                .catch(err => {
                    alert(
                        'Something went wrong!'
                    );
                }
                )
            fetch(`https://crewcoin.herokuapp.com/crewuser/${user.portalId}`, {
                method: "GET",
                headers: {
                    authorization: `bearer ${token}`,
                    credentials: "same-origin",
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    mode: "cors"
                },
            })
                .then(res => res.json())
                .then(res => {
                    if (res) {
                        setData(res);
                    } else {
                        alert("Error fetching user data. Please try again.")
                    }
                })
                .catch(err => {
                    console.log(err);
                }
                );
        }

    }

    function closeProfilePanel() {
        setIsClosingProfilePanel(true);
        setTimeout(() => {
            setShowProfilePanel(false);
            setIsClosingProfilePanel(false);
        }, 200);
    }

    function saveProfile() {
        if (!user?._id) return;
        setProfileSaving(true);

        fetch(`https://crewcoin.herokuapp.com/crewuser/profile/${user._id}`, {
            method: "PUT",
            headers: {
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
            body: JSON.stringify({
                firstname: String(profileForm.firstname || '').trim(),
                lastname: String(profileForm.lastname || '').trim(),
                phone: String(profileForm.phone || '').trim(),
                organization: user?.admin ? String(profileForm.organization || '').trim() : undefined,
                email: user?.username,
            }),
        })
            .then(res => res.json())
            .then(res => {
                if (res?.success && res?.crewuser) {
                    setUser(res.crewuser);
                    setSelf(res.crewuser);
                    closeProfilePanel();
                    return;
                }
                alert(res?.message || 'Unable to update profile.');
            })
            .catch(() => alert('Unable to update profile right now.'))
            .finally(() => setProfileSaving(false));
    }

    function loadEarnTasks() {
        fetch(`https://crewcoin.herokuapp.com/earn/${user.portalId}`, {
            method: "GET",
            headers: {
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res?.success) {
                    setEarnTasks(Array.isArray(res.earn) ? res.earn : []);
                }
            })
            .catch(err => console.log(err));
    }

    function openBillingPortal() {
        if (!token) {
            alert('Please log in again to manage billing.');
            return;
        }

        fetch('https://crewcoin.herokuapp.com/billing/create-portal-session', {
            method: 'POST',
            headers: {
                authorization: `bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                mode: 'cors'
            },
        })
            .then(res => res.json())
            .then(res => {
                if (!res?.success || !res?.portalUrl) {
                    alert(res?.message || 'Unable to open billing portal right now.');
                    return;
                }

                const proceed = window.confirm("You will be redirected to Stripe's secure billing portal to manage or cancel your subscription. Continue?");
                if (!proceed) return;

                window.location.href = res.portalUrl;
            })
            .catch(() => {
                alert('Unable to open billing portal right now.');
            });
    }

    function requireActiveBilling() {
        if (!billingBlocked) return true;
        alert('Your subscription is inactive. Please reactivate billing to use admin actions.');
        return false;
    }

    function resendSignupPoster() {
        if (!requireActiveBilling()) return;
        setPosterEmail(user?.email || user?.username || '');
        setShowPosterEmailModal(true);
    }

    function submitResendSignupPoster() {
        const enteredEmail = String(posterEmail || '').trim();

        if (!enteredEmail) {
            alert('Please enter an email address.');
            return;
        }

        const emailLooksValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(enteredEmail);
        if (!emailLooksValid) {
            alert('Please enter a valid email address.');
            return;
        }

        setResendingPoster(true);

        fetch('https://crewcoin.herokuapp.com/crewuser/resend-signup-poster', {
            method: 'POST',
            headers: {
                authorization: `bearer ${token}`,
                Accept: 'application/json',
                'Content-Type': 'application/json',
                mode: 'cors'
            },
            body: JSON.stringify({ email: enteredEmail }),
        })
            .then((res) => res.json())
            .then((res) => {
                if (res?.success) {
                    alert(res?.message || `Signup poster email sent to ${enteredEmail}.`);
                    setShowPosterEmailModal(false);
                    return;
                }

                alert(res?.message || 'Could not resend signup poster right now.');
            })
            .catch(() => {
                alert('Could not resend signup poster right now.');
            })
            .finally(() => setResendingPoster(false));
    }

    function addEarnTask() {
        if (!requireActiveBilling()) return;
        if (!earnForm.title || Number(earnForm.coins) <= 0) {
            alert('Please add a challenge title and coin amount greater than 0.');
            return;
        }

        if (earnForm.scope === 'selected' && !earnForm.assignedUserId) {
            alert('Please pick one user for personal challenge.');
            return;
        }

        setEarnSaving(true);

        fetch(`https://crewcoin.herokuapp.com/earn/${user.portalId}`, {
            method: "POST",
            headers: {
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
            body: JSON.stringify({
                title: earnForm.title,
                coins: Number(earnForm.coins),
                createdBy: user.username,
                scope: earnForm.scope,
                assignedUserIds: earnForm.scope === 'selected' ? [String(earnForm.assignedUserId)] : [],
                expiresAt: earnForm.expiresOn ? `${earnForm.expiresOn}T23:59:59.999Z` : null,
            }),
        })
            .then(res => res.json())
            .then(res => {
                if (res?.success) {
                    setEarnForm({ title: "", coins: "", scope: "all", assignedUserId: "", expiresOn: "" });
                    loadEarnTasks();
                    return;
                }

                alert('Could not create challenge right now.');
            })
            .catch(() => alert('Could not create challenge right now.'))
            .finally(() => setEarnSaving(false));
    }

    function archiveEarnTask(id) {
        if (!requireActiveBilling()) return;
        fetch(`https://crewcoin.herokuapp.com/earn/item/${id}`, {
            method: "PUT",
            headers: {
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
            body: JSON.stringify({ active: false }),
        })
            .then(res => res.json())
            .then(res => {
                if (res?.success) {
                    loadEarnTasks();
                }
            })
            .catch(err => console.log(err));
    }

    const badgeSummary = buildBadgeSummary();

    function renderBadgesSection() {
        return (
            <Container
                fluid
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingLeft: 0,
                    paddingRight: 0,
                }}
            >
                <div

                    style={{
                        width: 'min(980px, calc(100vw - 24px))',
                        margin: '0 auto',
                        padding: '5px 3px',
                    }}
                >
                    <h3 className="text-center mb-2">{user.admin ? `Motivation Meter` : 'Badges'}</h3>
                    <hr />
                    <div className="d-flex justify-content-center align-items-center mb-2" style={{ gap: 8 }}>
                        <Badge bg="warning" text="dark" style={{ fontSize: 12, padding: '6px 10px' }}>
                            Level {badgeSummary.level}
                        </Badge>
                        <small className="text-muted" style={{ fontWeight: 600 }}>
                            {badgeSummary.unlockedCount}/{badgeSummary.badges.length} unlocked ({badgeSummary.completionPercent}%)
                        </small>
                    </div>
                    <div style={{ maxWidth: 420, margin: '0 auto 12px auto', height: 10, background: '#f3f4f6', borderRadius: 999, overflow: 'hidden' }}>
                        <div style={{ height: '100%', width: `${badgeSummary.completionPercent}%`, background: 'linear-gradient(90deg,#fde68a,#facc15,#eab308)' }} />
                    </div>
                    <div style={{ margin: '0 auto' }}>
                        <div className="mx-0" style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
                            {badgeSummary.badges.map((b, idx) => (
                                <div
                                    key={idx}
                                    className="px-1 py-1 mb-5 d-flex justify-content-center"
                                    style={{ width: '33.3333%', maxWidth: '33.3333%' }}
                                >
                                    <Card
                                        style={{
                                            width: 80,
                                            minWidth: 80,
                                            maxWidth: 80,
                                            height: 70,
                                            border: b.unlocked ? '2px solid #fff200' : '2px solid #cbd5e1',
                                            backgroundColor: b.unlocked ? '#fffbeb' : '#f8fafc',
                                            boxShadow: b.unlocked ? '0 6px 16px rgba(245,158,11,0.25)' : '0 4px 10px rgba(15,23,42,0.08)',
                                            borderRadius: 12,
                                            overflow: 'hidden',
                                        }}
                                    >
                                        <Card.Body className="text-center p-2 d-flex flex-column align-items-center justify-content-center">
                                            <FontAwesomeIcon icon={b.icon} size="lg" color={b.unlocked ? '#ffae00' : '#64748b'} />
                                            <div className="mt-2" style={{ fontSize: 10, fontWeight: 700, lineHeight: '12px', minHeight: 24 }}>{b.label}</div>
                                            <div style={{ fontSize: 9, color: b.unlocked ? '#92400e' : '#64748b' }}>{b.unlocked ? 'Unlocked' : 'Locked'}</div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    function renderEarnSection() {
        const activeTasks = activeEarnTasksForCurrentUser();

        return (
            <Container className="mt-4">
                    <div style={{ position: 'relative', textAlign: 'center', marginBottom: 12 }}>
                        <h3 className="mb-0" style={{ fontWeight: 800, color: '#0f172a' }}>My Challenges</h3>
                        <Button
                            size="sm"
                            onClick={() => { earnHeight === 0 ? setEarnHeight('auto') : setEarnHeight(0) }}
                            style={{
                                position: 'absolute',
                                right: 0,
                                top: '50%',
                                transform: 'translateY(-50%)',
                                minWidth: (typeof window !== 'undefined' && window.innerWidth < 576) ? 30 : 98,
                                padding: (typeof window !== 'undefined' && window.innerWidth < 576) ? '0 2px' : '4px 8px',
                                borderRadius: 999,
                                border: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : '1px solid #93c5fd',
                                background: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'transparent' : '#eff6ff',
                                boxShadow: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : undefined,
                                color: '#1d4ed8',
                                fontWeight: 700,
                                fontSize: 12,
                            }}
                        >
                            <span className="d-inline d-sm-none" style={{ fontSize: 24, fontWeight: 800, lineHeight: 1 }}>{earnHeight === 0 ? '+' : '-'}</span>
                            <span className="d-none d-sm-inline">{earnHeight === 0 ? 'Expand' : 'Collapse'}</span>
                        </Button>
                    </div>
                    <hr style={{ borderTop: '1px solid #bfdbfe' }} />
                    <p className="text-center font-italic" style={{ color: '#334155' }}>Create and update challenges</p>

                    <AnimateHeight
                        id='earn-panel'
                        aria-hidden="false"
                        duration={500}
                        height={earnHeight}
                    >
                    {user.admin ? (
                        <Row className="justify-content-center mb-4 mx-0">
                            <Col xs={2} />
                            <Col className="px-0 mx-auto">
                                <Card className="shadow-sm" style={{ backgroundColor: '#ffffff', border: '1px solid #cfe3ff', borderRadius: 14 }}>
                                    <Card.Body>
                                        <h5 className="text-center mb-1" style={{ fontWeight: 800, color: '#0f172a' }}>Create Challenge</h5>
                                        <p className="text-center" style={{ fontSize: 12, color: '#64748b', marginBottom: 14 }}>Set a clear goal, reward, and audience.</p>
                                        <Form.Group className="mb-2 mx-2 my-2">
                                            <Form.Control
                                                placeholder="Challenge title"
                                                value={earnForm.title}
                                                onChange={(e) => setEarnForm({ ...earnForm, title: e.target.value })}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-2 mx-2 my-2">
                                            <Form.Control
                                                type="number"
                                                min="1"
                                                placeholder="Coin reward"
                                                value={earnForm.coins}
                                                onChange={(e) => setEarnForm({ ...earnForm, coins: e.target.value })}
                                            />
                                        </Form.Group>
                                        <Form.Group className="mb-2 mx-2 my-2">
                                        <Form.Control
                                            as="select"
                                            className=""
                                            value={earnForm.scope}
                                            onChange={(e) => setEarnForm({ ...earnForm, scope: e.target.value, assignedUserId: '' })}
                                            style={{ position: 'relative', zIndex: 2 }}
                                        >
                                            <option value="all">Open to all</option>
                                            <option value="selected">One user</option>
                                        </Form.Control>
                                        {earnForm.scope === 'selected' ? (
                                            <Form.Control
                                                as="select"
                                                className=" my-2"
                                                value={earnForm.assignedUserId}
                                                onChange={(e) => setEarnForm({ ...earnForm, assignedUserId: e.target.value })}
                                                style={{ position: 'relative', zIndex: 2 }}
                                            >
                                                <option value="">Select user</option>
                                                {(userData || []).filter((u) => !u.admin).map((u) => (
                                                    <option key={u._id} value={u._id}>{u.firstname} {u.lastname}</option>
                                                ))}
                                            </Form.Control>
                                        ) : null}
                                        </Form.Group>
                                        <Form.Group className="mb-3 mx-2 my-2">
                                            <Form.Control
                                                type="date"
                                                value={earnForm.expiresOn}
                                                onChange={(e) => setEarnForm({ ...earnForm, expiresOn: e.target.value })}
                                            />
                                        </Form.Group>
                                        <div className="text-center  mx-2 my-2">
                                            <Button
                                                disabled={earnSaving}
                                                onClick={addEarnTask}
                                                style={{
                                                    background: 'linear-gradient(135deg, #2563eb, #1d4ed8)',
                                                    border: 'none',
                                                    borderRadius: 10,
                                                    color: '#fff',
                                                    fontWeight: 700,
                                                    padding: '8px 14px',
                                                }}
                                            >
                                                {earnSaving ? 'Saving...' : 'Publish Challenge'}
                                            </Button>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                            <Col xs={2} />
                        </Row>
                    ) : null}

                    <div className="text-center mb-3" style={{ marginTop: 4 }}>
                        <h5 style={{ marginBottom: 4, fontWeight: 800, color: '#0f172a' }}>Active Challenges</h5>
                        <small style={{ color: '#64748b' }}>{activeTasks.length} currently live</small>
                    </div>
                    {activeTasks.length === 0 ? <p className="text-center" style={{ color: '#64748b' }}><i>No active challenges right now.</i></p> : null}
                    <Row className="text-center justify-content-center mx-0">
                        <Col xs={12} className="text-center px-0 d-flex justify-content-center">
                            <div style={{ width: 'min(100%, 420px)' }}>
                                {activeTasks.map((task) => {
                                    const assignedId = String(task?.assignedUserIds?.[0] || '');
                                    const personal = task.scope === 'selected' && assignedId === String(user._id);
                                    const assignedUser = (userData || []).find((u) => String(u._id) === assignedId);
                                    return (
                                        <Card
                                            key={task._id}
                                            className="mb-3 shadow"
                                            style={{
                                                border: '1px solid #cbd5e1',
                                                borderLeft: '5px solid #2563eb',
                                                borderRadius: 10,
                                                boxShadow: '0 8px 18px rgba(30,64,175,0.12)',
                                                background: '#ffffff',
                                            }}
                                        >
                                            <Card.Body>
                                                <div className=" text-center align-items-center">
                                                    <strong className=" text-center">{task.title}</strong>
                                                </div>
                                                <hr className="lessMargin" />
                                                <div style={{ marginTop: 2 }}>
                                                    <small style={{ color: '#0f766e', fontWeight: 700 }}>Reward: +{task.coins} coins</small>
                                                </div>
                                                <div style={{ marginTop: 4 }}>
                                                    {personal ? <Badge bg="warning" text="dark">Personal</Badge> : (task.scope === 'selected' ? <Badge bg="primary" text="light">Assigned</Badge> : <Badge bg="secondary" text="light">Open</Badge>)}
                                                    <small className="text-muted" style={{ marginLeft: 8 }}>
                                                        {task.scope === 'selected' ? `${assignedUser ? `${assignedUser.firstname} ${assignedUser.lastname}` : 'Selected user'}` : 'Available to everyone'}
                                                    </small>
                                                </div>
                                                {task?.expiresAt ? (
                                                    <div>
                                                        <small className="text-muted px-2">Expires: {moment(task.expiresAt).format('MM/DD/YYYY')}</small>
                                                        {isTaskExpired(task) ? (
                                                            <div>
                                                                <small className="px-2" style={{ color: '#dc2626', fontWeight: 700 }}>Overdue</small>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                ) : <div><small className="text-muted px-2">No expiration</small></div>}
                                                {user.admin ? (
                                                    <div className="my-1 d-flex justify-content-center">
                                                        <Button
                                                            size="sm"
                                                            onClick={() => archiveEarnTask(task._id)}
                                                            style={{
                                                                backgroundColor: '#fff',
                                                                borderColor: '#dc2626',
                                                                color: '#b91c1c',
                                                                borderRadius: 8,
                                                                boxShadow: '0 4px 10px rgba(185,28,28,0.16)',
                                                                padding: '4px 12px',
                                                                fontSize: 12,
                                                                fontWeight: 700,
                                                                lineHeight: 1.2,
                                                                marginBottom: "3px"
                                                            }}
                                                        >
                                                            End Challenge
                                                        </Button>
                                                    </div>
                                                ) : null}
                                            </Card.Body>
                                        </Card>
                                    );
                                })}
                            </div>
                        </Col>
                    </Row>
                    </AnimateHeight>
            </Container>
        );
    }


    function renderAnalyticsSection() {
        const snapshot = buildAnalyticsSnapshot();
        const challengeGoal = Math.max(10, snapshot.totalEmployees * 2);
        const challengeProgress = Math.min(100, Math.round((snapshot.challengesCompleted7d / challengeGoal) * 100));
        const isTouchDevice = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(hover: none)').matches;

        const turnoverAgeDays = Number(
            turnoverSummary?.accountAgeDays
            ?? turnoverSummary?.portalAgeDays
            ?? turnoverSummary?.daysSincePortalCreated
            ?? 0
        );
        const turnoverUnderOneYear = Boolean(turnoverSummary?.isLessThanOneYear) || (turnoverAgeDays > 0 && turnoverAgeDays < 365);

        const cards = [
            {
                title: 'Engagement Score',
                value: `${snapshot.engagementScore}%`,
                subtitle: 'Depth of participation this week',
                accent: '#38bdf8',
                labelColor: '#0369a1',
                icon: faChartLine,
                trend: snapshot?.trends?.engagementScore || 0,
                insight: 'Shows how strongly your team is participating this week across core actions. Deeper participation usually leads to better habits, stronger culture, and more consistent performance.'
            },
            {
                title: 'Active Employees',
                value: `${snapshot.activeEmployees} / ${snapshot.totalEmployees}`,
                subtitle: 'Participated this week',
                accent: '#facc15',
                labelColor: '#9a6700',
                icon: faUsers,
                trend: snapshot?.trends?.activeEmployees || 0,
                insight: 'Shows how many employees were active in the selected period. This shows whether adoption is broad across the team, not just concentrated in a few people.'
            },
            {
                title: 'Coins Issued (7 days)',
                value: `+${snapshot.coinsIssued7d}`,
                subtitle: 'Recognition sent this week',
                accent: '#d4af37',
                labelColor: '#9a6700',
                icon: faCoins,
                trend: snapshot?.trends?.coinsIssued7d || 0,
                insight: 'Shows how much recognition value was issued to employees recently. Steady recognition reinforces desired behaviors and keeps motivation visible.'
            },
            {
                title: 'Challenges Completed',
                value: `${snapshot.challengesCompleted7d}`,
                subtitle: 'Completion notifications this week',
                accent: '#ca8a04',
                labelColor: '#9a6700',
                icon: faCircleCheck,
                trend: snapshot?.trends?.challengesCompleted7d || 0,
                insight: 'Shows how many challenges were completed in the selected window. Challenge completions indicate real behavior change, not just passive app usage.'
            },
            {
                title: 'Annual Turnover',
                value: `${Number(turnoverSummary?.annualTurnoverPercent || 0).toFixed(1)}%`,
                subtitle: turnoverUnderOneYear
                    ? `${turnoverSummary?.leavesLast12Months || 0} left so far (account under 1 year)`
                    : `${turnoverSummary?.leavesLast12Months || 0} left in last 12 months`,
                accent: '#7c3aed',
                labelColor: '#5b21b6',
                icon: faUsers,
                trend: null,
                insight: 'Shows your estimated turnover rate for the measured period. Retention directly impacts labor cost, training burden, and store consistency.'
            },
            {
                title: 'Announcements Created (7 days)',
                value: `${snapshot.announcementsCreated7d}`,
                subtitle: snapshot.announcementsCreated7d >= 2 ? 'On pace (goal: 2/week)' : 'Goal: 2 per week',
                accent: snapshot.announcementsCreated7d >= 2 ? '#16a34a' : '#dc2626',
                labelColor: snapshot.announcementsCreated7d >= 2 ? '#166534' : '#b91c1c',
                icon: faBullhorn,
                trend: snapshot?.trends?.announcementsCreated7d || 0,
                insight: 'Shows how often leadership communicated updates to the team recently. This is important because clear communication drives alignment and increases participation in challenges and rewards.'
            },
        ];

        const trendChip = (trend) => {
            if (trend === null || trend === undefined) {
                return { text: 'No baseline yet', color: '#6b7280', bg: '#f3f4f6' };
            }
            if (trend > 0) {
                return { text: `+${trend} vs last 7d`, color: '#166534', bg: '#dcfce7' };
            }
            if (trend < 0) {
                return { text: `${trend} vs last 7d`, color: '#b91c1c', bg: '#fee2e2' };
            }
            return { text: 'No change vs last 7d', color: '#92400e', bg: '#fef3c7' };
        };

        return (
            <Container fluid className="mt-4" style={{ display: 'flex', justifyContent: 'center', paddingLeft: 0, paddingRight: 0 }}>
                <div className="borderRound shadow" style={{ width: 'min(1140px, calc(100vw - 24px))', margin: '0 auto', padding: '20px 16px', background: '#ffffff', border: '1px solid #dbeafe' }}>
                    <div className="d-flex flex-wrap justify-content-between align-items-center mb-3" style={{ rowGap: 8 }}>
                        <div>
                            <h3 style={{ marginBottom: 4, color: '#0c4a6e' }}>Analytics</h3>
                            <p style={{ marginBottom: 0, color: '#6b7280' }}>Is my team engaged, and who needs attention?</p>
                        </div>
                        <Badge bg="warning" text="dark" style={{ fontSize: 12, padding: '8px 10px' }}>Updated from live app activity</Badge>
                    </div>

                    <Row className="g-3 mx-0 mt-1">
                        <Col xs={12} className="px-1 d-flex">
                            <Card style={{ width: '100%', border: '1px solid #dbeafe', borderRadius: 12, background: '#ffffff' }}>
                                <Card.Body className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: 220, padding: '14px 14px 12px 14px' }}>
                                    <h5 className="mb-3" style={{ color: '#0c4a6e' }}>Engagement Circle</h5>
                                    <div style={{ width: 170, height: 170, borderRadius: '50%', background: `conic-gradient(#0ea5e9 ${snapshot.engagementScore}%, #f3f4f6 0)`, display: 'grid', placeItems: 'center' }}>
                                        <div style={{ width: 125, height: 125, borderRadius: '50%', background: '#fff', display: 'grid', placeItems: 'center', textAlign: 'center', border: '1px solid #f3f4f6' }}>
                                            <div>
                                                <div style={{ fontSize: 30, fontWeight: 800, color: '#111827' }}>{snapshot.engagementScore}%</div>
                                                <small style={{ color: '#6b7280' }}>Engaged</small>
                                            </div>
                                        </div>
                                    </div>
                                    <small className="mt-3" style={{ color: '#6b7280' }}>Employees who earned or redeemed this week</small>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="g-3 mb-1 mx-0 mt-1">
                        {cards.map((card) => {
                            const chip = trendChip(card.trend);
                            const isTurnoverCard = card.title === 'Annual Turnover';
                            const chipStyle = isTurnoverCard
                                ? { bg: '#f3f4f6', color: '#4b5563' }
                                : { bg: chip.bg, color: chip.color };
                            const chipText = isTurnoverCard
                                ? (turnoverUnderOneYear
                                    ? `*Early account: turnover is directional until 12 months`
                                    : `${turnoverSummary?.leavesLast12Months || 0} exits in 12m`)
                                : chip.text;
                            return (
                            <Col key={card.title} xs={12} sm={6} xl={3} className="px-1 d-flex">
                                <Card onMouseEnter={() => !isTouchDevice && setOpenInsightCard(card.title)} onMouseLeave={() => !isTouchDevice && setOpenInsightCard((prev) => (prev === card.title ? null : prev))} style={{ width: '100%', minHeight: 145, border: `1px solid ${card.accent}66`, background: '#fffdf5', borderRadius: 12, boxShadow: '0 6px 16px rgba(15,23,42,0.08)', transition: 'all .2s ease', overflow: 'visible' }}>
                                    <Card.Body className="d-flex flex-column justify-content-between" style={{ padding: '14px 14px 12px 14px', position: 'relative', overflow: 'visible' }}>
                                        <div className="d-flex justify-content-between align-items-start">
                                            <small style={{ color: card.labelColor || '#9a6700', textTransform: 'uppercase', letterSpacing: '.07em', fontWeight: 700, paddingRight: 6 }}>{card.title}</small>
                                            <div className="d-flex align-items-start" style={{ gap: 8 }}>
                                                <button
                                                    type="button"
                                                    className="metric-insight-trigger"
                                                    aria-label={`${card.title} insight`}
                                                    onClick={() => setOpenInsightCard((prev) => (prev === card.title ? null : card.title))}
                                                    style={{ border: 'none', background: 'transparent', color: '#475569', padding: 0, lineHeight: 1 }}
                                                >
                                                    <FontAwesomeIcon icon={faCircleInfo} style={{ fontSize: 14 }} />
                                                </button>
                                                <FontAwesomeIcon icon={card.icon} style={{ color: card.accent, fontSize: 16, opacity: 0.95 }} />
                                            </div>
                                        </div>
                                        {openInsightCard === card.title ? (
                                            <div className="metric-insight-popover" style={{ position: 'absolute', top: 34, left: 10, right: 10, zIndex: 50, border: '1px solid #cbd5e1', background: '#f8fafc', color: '#334155', borderRadius: 8, fontSize: 12, lineHeight: 1.35, padding: '8px 9px', boxShadow: '0 10px 20px rgba(15,23,42,0.14)' }}>
                                                {card.insight}
                                            </div>
                                        ) : null}
                                        <h2 style={{ margin: '6px 0 3px 0', color: '#111827', fontWeight: 800 }}>{card.value}</h2>
                                        <small style={{ color: '#6b7280' }}>{card.subtitle}</small>
                                        <div className="mt-2" style={{ width: 'fit-content', padding: '2px 8px', borderRadius: 999, background: chipStyle.bg, color: chipStyle.color, fontSize: 11, fontWeight: 700 }}>
                                            {chipText}
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )})}
                    </Row>

                    <Card className="mt-3" style={{ border: '1px solid #dbeafe', borderRadius: 12, background: '#ffffff' }}>
                        <Card.Body style={{ padding: '14px 14px 12px 14px' }}>
                            <h5 className="mb-2 d-flex align-items-center" style={{ color: '#0c4a6e', gap: 8 }}>
                                <FontAwesomeIcon icon={faTriangleExclamation} style={{ color: '#d97706' }} />
                                <span>Needs Attention</span>
                            </h5>
                            {snapshot.usersNeedingAttention.length === 0 ? (
                                <small style={{ color: '#15803d' }}>Nice — everyone has engaged in the last 7 days.</small>
                            ) : (
                                <div>
                                    {snapshot.usersNeedingAttention.map((u) => (
                                        <div key={u.id} className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: '1px solid #f3f4f6' }}>
                                            <span style={{ color: '#1f2937' }}>{u.name}</span>
                                            <small style={{ color: '#b45309' }}>{u.lastActivityAt ? `Last activity: ${moment(u.lastActivityAt).format('MM/DD')}` : 'No activity yet'}</small>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </Card.Body>
                    </Card>

                    <Row className="g-3 mx-0 mt-1">
                        <Col xs={12} className="px-1 d-flex">
                            <Card style={{ width: '100%', border: '1px solid #dbeafe', borderRadius: 12, background: '#ffffff' }}>
                                <Card.Body style={{ padding: '14px 14px 12px 14px' }}>
                                    <h5 className="mb-3" style={{ color: '#0c4a6e' }}>Team Activity Progress</h5>
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between mb-1" style={{ color: '#374151' }}><small>Engagement Score</small><small>{snapshot.engagementScore}%</small></div>
                                        <div style={{ height: 10, background: '#f3f4f6', borderRadius: 99, overflow: 'hidden' }}>
                                            <div style={{ height: '100%', width: `${snapshot.engagementScore}%`, background: 'linear-gradient(90deg,#7dd3fc,#0ea5e9)', transition: 'width .8s ease' }} />
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between mb-1" style={{ color: '#374151' }}><small>Employees Active</small><small>{snapshot.activeEmployees}/{snapshot.totalEmployees}</small></div>
                                        <div style={{ height: 10, background: '#f3f4f6', borderRadius: 99, overflow: 'hidden' }}>
                                            <div style={{ height: '100%', width: `${snapshot.totalEmployees ? Math.round((snapshot.activeEmployees / snapshot.totalEmployees) * 100) : 0}%`, background: 'linear-gradient(90deg,#fcd34d,#f59e0b)', transition: 'width .8s ease' }} />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="d-flex justify-content-between mb-1" style={{ color: '#374151' }}><small>Challenge Completion Pace</small><small>{challengeProgress}%</small></div>
                                        <div style={{ height: 10, background: '#f3f4f6', borderRadius: 99, overflow: 'hidden' }}>
                                            <div style={{ height: '100%', width: `${challengeProgress}%`, background: 'linear-gradient(90deg,#fde68a,#d97706)', transition: 'width .8s ease' }} />
                                        </div>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    <Row className="g-3 mx-0 mt-1">
                        <Col xs={12} className="px-1 d-flex">
                            <Card style={{ width: '100%', border: '1px solid #dbeafe', borderRadius: 12, background: '#ffffff' }}>
                                <Card.Body style={{ padding: '14px 14px 12px 14px' }}>
                                    <h5 className="mb-3" style={{ color: '#0c4a6e' }}>Financial Health</h5>
                                    <Row className="g-2">
                                        <Col xs={12} md={6}>
                                            <div className="borderRound" style={{ border: '1px solid #e5e7eb', padding: '10px 12px', background: '#ffffff' }}>
                                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                    <FontAwesomeIcon icon={faCoins} style={{ color: '#b45309', fontSize: 16 }} />
                                                    <small style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.07em', color: '#9a6700' }}>Coins in Circulation</small>
                                                </div>
                                                <div style={{ fontSize: 26, fontWeight: 800, color: '#111827', marginTop: 4 }}>{snapshot.coinsInCirculation}</div>
                                                <div style={{ width: 'fit-content', padding: '3px 8px', borderRadius: 999, background: '#f3f4f6', color: '#4b5563', fontSize: 11, fontWeight: 700 }}>
                                                    {(snapshot?.trends?.coinsInCirculation30d || 0) > 0 ? '+' : ''}{snapshot?.trends?.coinsInCirculation30d || 0} vs 30d ago
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} md={6}>
                                            <div className="borderRound" style={{ border: '1px solid #e5e7eb', padding: '10px 12px', background: '#f8fafc' }}>
                                                <div className="d-flex align-items-center" style={{ gap: 8 }}>
                                                    <FontAwesomeIcon icon={faCartShopping} style={{ color: '#0c4a6e', fontSize: 16 }} />
                                                    <small style={{ fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.07em', color: '#0c4a6e' }}>Purchases (Last 30 Days)</small>
                                                </div>
                                                <div style={{ fontSize: 26, fontWeight: 800, color: '#111827', marginTop: 4 }}>{snapshot.purchasesLast30d}</div>
                                                <div style={{ width: 'fit-content', padding: '3px 8px', borderRadius: 999, background: '#f3f4f6', color: '#4b5563', fontSize: 11, fontWeight: 700 }}>
                                                    Redeems + purchases in 30d
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>

                    {renderBadgesSection()}
                </div>
            </Container>
        );
    }



    React.useEffect(() => {
        fetch(`https://crewcoin.herokuapp.com/crewuser/${user.portalId}`, {
            method: "GET",
            headers: {
                authorization: `bearer ${token}`,
                credentials: "same-origin",
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res) {
                    setData(res);
                    const myself = res.find(user => user.username === self.username);
                    setUser(myself);
                } else {
                    alert("Error fetching user data. Please try again.")
                }
            })
            .catch(err => {
                console.log(err);
            }
            );
        fetch(`https://crewcoin.herokuapp.com/store/${user.portalId}`, {
            method: "GET",
            headers: {
                authorization: "jwt",
                credentials: "same-origin",
                Accept: "application/json, text/html, */*",
                "Content-Type": "application/json",
                mode: "cors"
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res.success) {
                    setPrizes(res.prizes);
                    console.log(prizes);
                } else {
                    alert("Error fetching user data. Please try again.")
                }
            })
            .catch(err => {
                console.log(err);
            }
            );

        fetch(`https://crewcoin.herokuapp.com/announcements/${user.portalId}`, {
            method: "GET",
            headers: {
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res?.success) {
                    setAnnouncementsData(Array.isArray(res.announcements) ? res.announcements : []);
                }
            })
            .catch(err => console.log(err));

        fetch(`https://crewcoin.herokuapp.com/crewuser/turnover/${user.portalId}`, {
            method: "GET",
            headers: {
                authorization: `bearer ${token}`,
                Accept: "application/json",
                "Content-Type": "application/json",
                mode: "cors"
            },
        })
            .then(res => res.json())
            .then(res => {
                if (res?.success && res?.turnover) {
                    setTurnoverSummary(res.turnover);
                }
            })
            .catch(err => console.log(err));

        loadEarnTasks();

    }, []);

    // Function to handle image selection and upload


    const handleImageUpload = () => {
        if (selectedFile) {
            console.log("Selected file:", selectedFile);

            // You can now pass the selected file to the image upload function.
            // For example, you can use a function that handles the upload logic.
            // handleUpload(selectedFile);
        } else {
            console.error("No file selected.");
        }
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        console.log(selectedFile)
        // Create a preview URL for the selected file
        const previewURL = URL.createObjectURL(file);
        setImagePreview(previewURL);
    };

    if (user.admin === true) {
        return (

            <div>
                <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h2 class="modal-title text-center" id="exampleModalLabel">Monthly Budget</h2>
                                <hr />
                                <p className="text-center">Need Help Controlling Your Spending?</p>
                            </div>
                            <div class="modal-body">
                                <img alt="crewcoingif" className="crewCoinGif" src={'../img/coinIcon2.gif'} />
                                <h3 className="text-center">Set Your Monthly Budget</h3>
                                <form className="width-35 mx-auto">
                                    <div className="form-group mx-auto px-5">
                                        <input
                                            width="50%"
                                            min="0"
                                            value={budget}
                                            defaultValue={user.budgetAmount}
                                            onChange={(value) => { setBudget(Number(value.target.value)) }}
                                            type="number"
                                            className="form-control text-center justify-content-center"
                                            id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Enter Amount"

                                        />
                                    </div>
                                </form>
                                <p className="text-center">Crew Coins will be added on the 1st of every month!</p>
                            </div>
                            <div class="modal-footer">
                                <div className="modalBudget">
                                    <h5 className="budgetModal">*Budget: {user.budgetAmount}</h5>
                                </div>
                                <button onClick={() => { setDisable(false); setBudget(user.budgetAmount) }} type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                <button disabled={disable} onClick={() => { setDisable(true); addBudget(self._id) }} type="button" class="btn btn-warning">Save Changes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* quickadd modal */}
                <div class="modal fade" id="quickAddModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h2 class="modal-title text-center" id="exampleModalLabel">Add Crew Coins</h2>
                                <hr />
                                <p className="text-center">Need Crew Coins now?</p>
                            </div>
                            <div class="modal-body">
                                <img alt="crewcoingif" className="crewCoinGif" src={'../img/coinIcon2.gif'} />
                                <h3 className="text-center">Increase Your Balance</h3>
                                <form className="width-35 mx-auto">
                                    <div className="form-group mx-auto px-5">
                                        <input

                                            min="0"
                                            defaultValue={coins}
                                            onChange={(value) => { setCoins(Number(value.target.value)) }}
                                            type="number"
                                            className="form-control text-center justify-content-center"
                                            id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Enter Amount"

                                        />
                                    </div>
                                </form>
                                <p className="text-center">Instantly add Crew Coins to your account!</p>
                            </div>
                            <div class="modal-footer">
                                <div className="modalBudget">
                                    <h5 className="budgetModal">*Balance: {user.balance}</h5>
                                </div>
                                <button onClick={() => { setDisable(false); setBudget(user.budgetAmount) }} type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                <Button disabled={disable} onClick={() => { setDisable(true); quickAddCoins(self._id) }} size="sm" variant="warning" className="mb-1"  >Add Coins</Button>
                            </div>
                        </div>
                    </div>
                </div>
                {/* newItem Modal */}
                <div class="modal fade" id="newItemModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title text-center" id="exampleModalLabel">NEW STORE ITEM</h4>
                            </div>
                            <div class="modal-body mx-auto">
                                <div className="text-center">
                                    <div style={{ display: imagePreview === null ? 'none' : 'block' }}>

                                        <img alt="previewImage" className="previewImage" src={imagePreview} style={{ maxWidth: '100%', height: 'auto' }} />
                                    </div>
                                </div>
                                <div>
                                    <form>
                                        <input type="file" id="imageInput" accept="image/*" onChange={handleFileChange} />
                                    </form>
                                </div>


                                <form>

                                    <div className="form-group mx-auto px-5">
                                        <input
                                            type="textarea"
                                            defaultValue={editPrize.title}
                                            onChange={(value) => { setEditPrize({ ...editPrize, description: value.target.value }) }}
                                            className="form-control mb-2 text-center justify-content-center"
                                            id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Title"


                                        />
                                        <input
                                            type="textarea"
                                            defaultValue={editPrize.description}
                                            onChange={(value) => { setEditPrize({ ...editPrize, description: value.target.value }) }}
                                            className="form-control text-center justify-content-center"
                                            id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Description"


                                        />
                                        <h5 className="text-center">Price:</h5>
                                        <input

                                            min="0"
                                            defaultValue={coins}
                                            onChange={(value) => { setCoins(Number(value.target.value)) }}
                                            type="number"
                                            className="form-control width-35 mx-auto text-center justify-content-center"
                                            id="exampleInputEmail1"
                                            aria-describedby="emailHelp"
                                            placeholder="Enter Amount"

                                        />
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button onClick={() => { setImagePreview(null); setSelectedFile(null) }} type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                                <Button disabled={disable} onClick={() => { setDisable(true); quickAddCoins(self._id) }} size="sm" variant="danger" className="mb-1"  >Add Item</Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <style>{`@keyframes slideInRight { from { transform: translateX(100%); opacity: 0.8; } to { transform: translateX(0); opacity: 1; } } @keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0.8; } } @keyframes fadeInFast { from { opacity: 0; } to { opacity: 1; } } @keyframes fadeOutFast { from { opacity: 1; } to { opacity: 0; } }`}</style>
                    <nav id='menu' className='navbar  navbar-default navbar-fixed-top'>
                        <div className='container'>
                            <div className='navbar-header'>
                                <button
                                    type='button'
                                    className='navbar-toggle collapsed'
                                    data-toggle='collapse'
                                    data-target='#bs-example-navbar-collapse-1'
                                >
                                    {' '}
                                    <span className='sr-only'>Toggle navigation</span>{' '}
                                    <span className='icon-bar'></span>{' '}
                                    <span className='icon-bar'></span>{' '}
                                    <span className='icon-bar'></span>{' '}
                                </button>
                                <button
                                    type='button'
                                    className='navbar-toggle'
                                    onClick={() => setShowProfilePanel(true)}
                                    aria-label='Edit profile'
                                    style={{ marginRight: 8, border: 'none', background: 'transparent', color: '#333' }}
                                >
                                    <FontAwesomeIcon icon={faCircleUser} size="lg" />
                                </button>
                                <ul className='navbar-nav navbar-left'>

                                    <li>
                                        <Link to="/">`
                                            <img alt="crewcoinlogo" className="crewcoinSm" src={'../img/crewcoinlogo.png'} />
                                        </Link>
                                    </li>
                                </ul>

                            </div>

                            <div
                                className='collapse navbar-collapse'
                                id='bs-example-navbar-collapse-1'
                            >
                                <ul className='nav navbar-nav navbar-right' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <li>
                                        <Link to="/">Logout</Link>
                                    </li>
                                    <li style={{ paddingTop: 10 }}>
                                        <button
                                            type="button"
                                            onClick={() => setShowProfilePanel(true)}
                                            style={{ border: 'none', background: 'transparent', color: '#333' }}
                                            aria-label="Edit profile"
                                        >
                                            <FontAwesomeIcon icon={faCircleUser} size="lg" />
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </nav>
                    {showProfilePanel && (
                        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1200, animation: isClosingProfilePanel ? 'fadeOutFast 200ms ease-in forwards' : 'fadeInFast 200ms ease-out' }} onClick={closeProfilePanel}>
                            <div style={{ position: 'absolute', right: 0, top: 0, width: 'min(92vw, 360px)', height: '100%', background: '#fff', padding: 20, animation: isClosingProfilePanel ? 'slideOutRight 200ms ease-in forwards' : 'slideInRight 220ms ease-out' }} onClick={(e) => e.stopPropagation()}>
                                <h4 style={{ marginTop: 0 }}>Edit Profile</h4>
                                <Form.Group className="mb-3"><Form.Label>First Name</Form.Label><Form.Control value={profileForm.firstname} onChange={(e) => setProfileForm({ ...profileForm, firstname: e.target.value })} /></Form.Group>
                                <Form.Group className="mb-3"><Form.Label>Last Name</Form.Label><Form.Control value={profileForm.lastname} onChange={(e) => setProfileForm({ ...profileForm, lastname: e.target.value })} /></Form.Group>
                                <Form.Group className="mb-3"><Form.Label>Phone</Form.Label><Form.Control value={profileForm.phone} onChange={(e) => setProfileForm({ ...profileForm, phone: e.target.value })} /></Form.Group>
                                {user?.admin && <Form.Group className="mb-3"><Form.Label>Organization Name</Form.Label><Form.Control value={profileForm.organization} onChange={(e) => setProfileForm({ ...profileForm, organization: e.target.value })} /></Form.Group>}
                                <Form.Group className="mb-3"><Form.Label>Email</Form.Label><Form.Control value={user?.username || ''} disabled /></Form.Group>
                                <div style={{ display: 'flex', gap: 8 }}>
                                    <Button variant="secondary" onClick={closeProfilePanel}>Cancel</Button>
                                    <Button onClick={saveProfile} disabled={profileSaving}>{profileSaving ? 'Saving...' : 'Save'}</Button>
                                </div>
                            </div>
                        </div>
                    )}
                    <br />
                    <Container className="mt-5 pt-5">
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 10,
                                flexWrap: 'wrap',
                            }}
                        >
                            <Button
                                data-toggle="modal"
                                data-target="#exampleModal"
                                className="mt-5 py-1 shadow mx-2"
                                style={{
                                    background: 'linear-gradient(135deg, #f59e0b, #f97316)',
                                    border: 'none',
                                    borderRadius: 10,
                                    color: '#fff',
                                    fontWeight: 700,
                                    letterSpacing: 0.2,
                                    padding: '8px 14px',
                                }}
                            >
                                Set Budget
                            </Button>
                            <Button
                                data-toggle="modal"
                                data-target="#quickAddModal"
                                className="mt-5 mx-2 py-1 shadow"
                                style={{
                                    background: 'linear-gradient(135deg, #0ea5e9, #2563eb)',
                                    border: 'none',
                                    borderRadius: 10,
                                    color: '#fff',
                                    fontWeight: 700,
                                    letterSpacing: 0.2,
                                    padding: '8px 14px',
                                }}
                            >
                                Add Coins
                            </Button>
                        </div>
                    </Container>
                    <Container>
                        <h3 className="mt-5 text-center">{user.firstname}, Welcome to your Dashboard!</h3>
                    </Container>
                    <Container>
                        <div className='col-sm-8 col-sm-offset-2 text-center mt-5'>
                            <Card
                                className=""
                                style={{
                                    borderRadius: 18,
                                    border: '1px solid #dbeafe',
                                    boxShadow: '0 14px 28px rgba(15, 23, 42, 0.08)',
                                    background: 'linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)',
                                }}
                            >
                                <Card.Body>
                                    <Card.Title>
                                        <h2 style={{ fontWeight: 800, color: '#0f172a' }}>{user.organization}</h2>
                                        <hr className="hr3" />
                                    </Card.Title>
                                    <Card.Text>
                                        <h4 style={{ color: '#334155' }}>PortalId: {user.portalId}</h4>
                                        <h4 style={{ color: '#0f766e', fontWeight: 800 }}>Balance: {user.balance}</h4>
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                    </Container>
                    {billingBlocked ? (
                        <Container className="mt-3">
                            <div className="borderRound" style={{ border: '1px solid #fecaca', background: '#fef2f2', color: '#991b1b', padding: '10px 14px', textAlign: 'center' }}>
                                Subscription inactive. Admin actions are disabled until billing is reactivated.
                            </div>
                        </Container>
                    ) : null}

                    <Container className="mt-3">
                        <div className="d-flex justify-content-center">
                            <div style={{ background: '#f8fafc', border: '1px solid #cbd5e1', borderRadius: 999, padding: 4 }}>
                                <Button
                                    size="sm"
                                    onClick={() => setDashboardView('operations')}
                                    style={{
                                        borderRadius: 999,
                                        border: 'none',
                                        marginRight: 6,
                                        backgroundColor: dashboardView === 'operations' ? '#facc15' : '#e2e8f0',
                                        color: '#1f2937',
                                        fontWeight: 700,
                                    }}
                                >
                                    Operations
                                </Button>
                                <Button
                                    size="sm"
                                    onClick={() => setDashboardView('analytics')}
                                    style={{
                                        borderRadius: 999,
                                        border: 'none',
                                        backgroundColor: dashboardView === 'analytics' ? '#38bdf8' : '#e2e8f0',
                                        color: '#0f172a',
                                        fontWeight: 700,
                                    }}
                                >
                                    Analytics
                                </Button>
                            </div>
                        </div>
                    </Container>

                    {dashboardView === 'analytics' ? (
                        <>
                            {renderAnalyticsSection()}
                            <div id='footer' className="border mt-5">
                                <div className='container text-center'>
                                    <p>
                                        &copy; 2022 Crew Coin. All Rights Reserved.
                                    </p>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                                        {user?.admin ? (
                                            <Button
                                                className="py-1 shadow"
                                                size="sm"
                                                onClick={resendSignupPoster}
                                                disabled={resendingPoster}
                                                style={{
                                                    background: 'linear-gradient(135deg, #f59e0b, #f97316)',
                                                    border: 'none',
                                                    borderRadius: 10,
                                                    color: '#fff',
                                                    fontWeight: 700,
                                                    letterSpacing: 0.2,
                                                    padding: '8px 14px',
                                                }}
                                            >
                                                {resendingPoster ? 'Sending...' : 'Resend Sign-Up Poster'}
                                            </Button>
                                        ) : null}
                                        <FAQWidget
                                            hideFloating
                                            buttonClassName="btn btn-sm py-1 shadow"
                                            buttonStyle={{
                                                background: 'linear-gradient(135deg, #06b6d4, #0ea5e9)',
                                                border: 'none',
                                                borderRadius: 10,
                                                color: '#fff',
                                                fontWeight: 700,
                                                letterSpacing: 0.2,
                                                padding: '8px 14px',
                                            }}
                                        />
                                    </div>
                                    <button
                                        onClick={openBillingPortal}
                                        style={{
                                            background: 'transparent',
                                            border: 'none',
                                            color: '#6b7280',
                                            fontSize: 12,
                                            textDecoration: 'underline',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Cancel subscription
                                    </button>
                                </div>
                            </div>
                            {showPosterEmailModal ? (
                                <div
                                    onClick={() => !resendingPoster && setShowPosterEmailModal(false)}
                                    style={{
                                        position: 'fixed',
                                        inset: 0,
                                        background: 'rgba(15,23,42,0.55)',
                                        zIndex: 99999,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: 16,
                                    }}
                                >
                                    <div
                                        onClick={(e) => e.stopPropagation()}
                                        style={{ background: '#fff', width: '100%', maxWidth: 460, borderRadius: 12, boxShadow: '0 20px 50px rgba(0,0,0,.25)' }}
                                    >
                                        <div style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: 800 }}>Resend Sign-Up Poster</div>
                                        <div style={{ padding: 16 }}>
                                            <Form.Group>
                                                <Form.Label>Email address</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    value={posterEmail}
                                                    onChange={(e) => setPosterEmail(e.target.value)}
                                                    placeholder="name@company.com"
                                                    autoFocus
                                                />
                                            </Form.Group>
                                        </div>
                                        <div style={{ padding: 16, borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                            <Button variant="secondary" onClick={() => setShowPosterEmailModal(false)} disabled={resendingPoster}>Cancel</Button>
                                            <Button onClick={submitResendSignupPoster} disabled={resendingPoster} style={{ background: 'linear-gradient(135deg, #f59e0b, #f97316)', border: 'none', color: '#fff', fontWeight: 700 }}>
                                                {resendingPoster ? 'Sending...' : 'Send Poster'}
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            ) : null}
                        </>
                    ) : null}

                    <div style={{ display: dashboardView === 'operations' ? 'block' : 'none' }}>
                    <Container
                        className="mt-3"
                        style={{
                            background: 'linear-gradient(180deg, #f8fafc 0%, #eef2ff 100%)',
                            border: '1px solid #dbeafe',
                            borderRadius: 16,
                            padding: '10px 10px 20px 10px',
                            boxShadow: '0 14px 30px rgba(15, 23, 42, 0.08)',
                        }}
                    >
                        <div className='col-sm-12 text-center mt-4 pb-5 limitHeight'>
                            <div style={{ marginBottom: 8 }}>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        background: '#1d4ed8',
                                        color: '#fff',
                                        borderRadius: 999,
                                        padding: '6px 14px',
                                        fontWeight: 700,
                                        fontSize: 12,
                                        letterSpacing: 0.4,
                                        textTransform: 'uppercase',
                                    }}
                                >
                                    Team Management
                                </span>
                            </div>
                            <h3 className="text-center" style={{ fontWeight: 800, color: '#0f172a' }}>Current Users</h3>
                            <hr style={{ borderTop: '1px solid #bfdbfe' }} />
                            <div className='mb-5 text-center'>
                                <Container>
                                    <Stack direction="horizontal" gap={2}>

                                        <div className="bg-light ms-auto col-sm-10"><h5> User</h5><hr className="hr2" /></div>
                                        <div className="bg-light col-sm-10 mx-2"><h5>Status</h5> <hr className="hr2" /></div>
                                    </Stack>
                                </Container>
                                {userData.map((user, i) => {
                                    function checkAdmin(user) {
                                        if (user.username === self.username) {
                                            return null;
                                        } else {

                                            if (!user.admin) {
                                                return (
                                                    <Button size="xs" className="btn btn-warning shadow" onClick={() => { setAdmin(user._id, user.admin) }}>Make Admin</Button>
                                                )
                                            } else {
                                                return (
                                                    <Button size="xs" className="btn btn-warning shadow" onClick={() => { setAdmin(user._id, user.admin) }}>Remove Admin Status</Button>
                                                )
                                            }
                                        }
                                    }

                                    function showUserInfo(user, i) {
                                        if (toggle === true && userData[i] === user[userIndex]) {
                                            return (
                                                <Stack direction="horizontal" gap={2}>
                                                    <div className="col-xs-12 mt-2 ">
                                                        <div className="bg-light ms-auto ">
                                                            <p><strong>Phone:</strong> {user[i].phone}</p>
                                                        </div>
                                                        <div className="bg-light ms-auto ">
                                                            <p><strong>Email:</strong> {user[i].username}</p>
                                                        </div>
                                                        <div className="bg-light ms-auto ">
                                                            <p><strong>Balance:</strong> {user[i].balance}</p>
                                                        </div>
                                                        <div className="bg-light ms-auto ">
                                                            <p><strong>Monthly Budget:</strong> {user[i].budgetAmount}</p>
                                                        </div>
                                                        <div className="bg-light ms-auto ">
                                                            <p><strong>Joined:</strong> {moment(user[i].createdAt).format("MM/DD/YYYY")}</p>
                                                        </div>
                                                        <div>
                                                            {checkAdmin(user[i])}


                                                        </div>
                                                    </div>
                                                </Stack>
                                            )
                                        } else {
                                            return null
                                        }

                                    }
                                    function admin() {
                                        if (user.admin === true) {
                                            return "Admin"
                                        } else {
                                            return "User"
                                        }
                                    }
                                    function buttonVariant() {
                                        if (user.username === self.username) {
                                            return "ghost"
                                        } else {
                                            return "danger"
                                        }
                                    }

                                    return (
                                        <Container key={i} className="mt-1" >
                                            <div className='col-sm-8 col-xs-offset-2 text-center mt-5'>
                                                <Stack direction="horizontal" gap={3}>
                                                    <Button style={{ marginLeft: "-17", width: "22px", height: "22px" }} key={i} size="xs" variant="info" className="mb-1 shadow" onClick={() => { setToggle(!toggle); setUserIndex(i) }}  >{buttonToggle(toggle)}</Button>
                                                    <div className="bg-light ms-auto "><strong>{user.firstname} {user.lastname}</strong></div>
                                                    <div className="bg-light px-3">{admin()}</div>
                                                    <div className="bg-light">
                                                        <Button onClick={() => {
                                                            if (user.username === self.username) {
                                                                return null
                                                            } else {
                                                                deleteUser(user._id, user.firstname + " " + user.lastname)
                                                            }
                                                        }}
                                                            key={user}
                                                            size="xs"
                                                            variant={
                                                                buttonVariant(user.username)
                                                            }
                                                            className="mb-1 shadow"
                                                        >
                                                            Delete
                                                        </Button>
                                                    </div>
                                                </Stack>
                                                {showUserInfo(userData, i)}
                                            </div>
                                        </Container>

                                    )
                                })}
                            </div>
                        </div>
                    </Container>
                    {renderEarnSection()}
                    <Container className="mt-4" >
                        <div style={{ position: 'relative', textAlign: 'center' }}>
                            <h3 id="myStore" style={{ fontWeight: 800, color: '#0f172a', margin: 0 }}>My Store</h3>
                            <Button
                                size="sm"
                                onClick={() => { height === 0 ? setHeight("auto") : setHeight(0) }}
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    minWidth: (typeof window !== 'undefined' && window.innerWidth < 576) ? 30 : 98,
                                    padding: (typeof window !== 'undefined' && window.innerWidth < 576) ? '0 2px' : '4px 8px',
                                    borderRadius: 999,
                                    border: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : '1px solid #93c5fd',
                                    background: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'transparent' : '#eff6ff',
                                    boxShadow: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : undefined,
                                    color: '#1d4ed8',
                                    fontWeight: 700,
                                    fontSize: 12,
                                }}
                            >
                                <span className="d-inline d-sm-none" style={{ fontSize: 24, fontWeight: 800, lineHeight: 1 }}>{height === 0 ? '+' : '-'}</span>
                                <span className="d-none d-sm-inline">{height === 0 ? 'Expand' : 'Collapse'}</span>
                            </Button>
                        </div>
                    </Container>
                    <hr style={{ borderTop: '1px solid #bfdbfe' }} />
                    <p className="text-center font-italic" style={{ color: '#334155' }}>View and edit store items</p>
                    <AnimateHeight
                        id='example-panel'
                        aria-hidden="false"
                        duration={500}
                        height={height} // see props documentation below
                    >
                        <Container className="borderRound shadow limitHeightSmall text-center" >
                            <div className="d-flex justify-content-center my-4">
                                <button
                                    data-toggle="modal"
                                    data-target="#newItemModal"
                                    className="text-center"
                                    style={{
                                        backgroundColor: '#facc15',
                                        border: '1px solid #eab308',
                                        color: '#3f2a00',
                                        borderRadius: 3,
                                        boxShadow: '0 6px 14px rgba(234,179,8,0.35)',
                                        padding: '6px 14px',
                                        fontSize: 12,
                                        fontWeight: 700,
                                        lineHeight: 1.2,
                                    }}
                                >
                                    + Add New Store Item
                                </button>
                            </div>
                            <div className=''>
                                <Stack style={{ height: 25 }} className=" pt-3 row sticky-top border bgwhite" direction="horizontal">

                                    <p style={{ width: "100px" }} className="col-xs-3 bold mx-3 raleway">Image</p>
                                    <p className="col-xs-4 bold raleway">Item</p>
                                    <p className="col-sm-4 hidden-xs bold raleway">Description</p>
                                    <p className="col-xs-3 bold raleway">Price</p>
                                </Stack>

                                {sorted.map((prize, i) => {

                                    function deletePrize(prize) {
                                        if (!requireActiveBilling()) return;
                                        let text = `Are you sure you want to delete ${prize.title}?`;;
                                        if (window.confirm(text)) {
                                            const storage = getStorage();
                                            var prizeRef = ref(storage, prize.image);

                                            // Delete the file
                                            deleteObject(prizeRef).then(() => {
                                                // File deleted successfully
                                            }).catch((error) => {
                                                // Uh-oh, an error occurred!
                                            });

                                            fetch(`https://crewcoin.herokuapp.com/store/${prize._id}`, {
                                                method: "DELETE",
                                                headers: {
                                                    authorization: `bearer ${token}`,
                                                    credentials: "same-origin",
                                                    Accept: "application/json",
                                                    "Content-Type": "application/json",
                                                    mode: "cors"
                                                },
                                                body: JSON.stringify({
                                                    "prizeId": prize._id
                                                }),
                                            })

                                                .then(res => res.json())
                                                .then(res => {
                                                    if (res.success) {
                                                        alert("Prize Deleted")
                                                        window.location.reload()
                                                    } else {
                                                        alert("Something went wrong")
                                                    }
                                                })
                                                .catch(err => {
                                                    console.log(err)
                                                }
                                                );
                                        }
                                    }
                                    function updatePrize(prize) {
                                        if (!requireActiveBilling()) return;

                                        fetch(`https://crewcoin.herokuapp.com/store/${prize._id}`, {
                                            method: "Put",
                                            headers: {
                                                authorization: `bearer ${token}`,
                                                credentials: "same-origin",
                                                Accept: "application/json",
                                                "Content-Type": "application/json",
                                                mode: "cors"
                                            },
                                            body: JSON.stringify({
                                                "title": editPrize.title,
                                                "description": editPrize.description,
                                                "cost": editPrize.cost,
                                            }),
                                        })

                                            .then(res => res.json())
                                            .then(res => {
                                                if (res.success) {
                                                    alert("Prize Updated")
                                                    window.location.reload()
                                                } else {
                                                    alert("Something went wrong")
                                                }
                                            })
                                            .catch(err => {
                                                console.log(err)
                                            }
                                            );

                                    }

                                    return (
                                        <div key={i} className="">
                                            <Stack data-toggle="modal" data-target={`#storeModal${i}`} key={i} style={{ height: 100 }} className=" my-2 row border hover " direction="horizontal">

                                                <img style={{ width: "100px" }} src={prize.image} alt="prize"
                                                    className="col-xs-3 borderRound mx-3 shadow" />
                                                <p className="col-xs-4 bold raleway">{prize.title}  </p>
                                                <p className="hidden-xs col-sm-4 raleway">{prize.description.substring(0, 20) + "..."}</p>
                                                <p className="col-xs-3 raleway goldColor">{coin(prize.cost)}</p>
                                            </Stack>
                                            <div key={i} class="modal backdrop position-static modalStore fade zindex" id={`storeModal${i}`} tabindex="-1" role="dialog" data-backdrop="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
                                                <div class="modal-dialog" role="document">
                                                    <div style={{ width: "75%", margin: "auto" }} class="modal-content">
                                                        <button type="button" className="close px-4 py-2" data-dismiss="modal" aria-label="Close">x</button>
                                                        <div class="modal-header">
                                                            <h4 class="modal-title text-center" id="exampleModalLabel">Edit Store Item</h4>
                                                        </div>
                                                        <div class="modal-body">
                                                            <img alt="crewcoingif" className="storeModalImg border2 shadow" src={prize.image} />
                                                            <h4 className="text-center goldColorSmall"><img alt="crewCoinGifSmall" className="crewCoinGifSmaller" src={'../img/coinIcon2.gif'} />{coin(prize.cost)}</h4>
                                                            <div className='form-group mb-5'>
                                                                <label htmlFor="title">Title:</label>
                                                                <input
                                                                    type='text'
                                                                    className='form-control col'
                                                                    defaultValue={prize.title}

                                                                    name='title'
                                                                    required
                                                                    onChange={(value) => { setEditPrize({ ...editPrize, title: value.target.value }) }}
                                                                />

                                                                <label htmlFor="description">Description:</label>
                                                                <input
                                                                    type='text'
                                                                    className='form-control col'
                                                                    defaultValue={prize.description}

                                                                    name='description'
                                                                    required
                                                                    onChange={(value) => { setEditPrize({ ...editPrize, description: value.target.value }) }}
                                                                />

                                                                <label htmlFor="cost">Cost:</label>
                                                                <input
                                                                    type='number'
                                                                    width='100px'
                                                                    className='form-control col-xs-4'
                                                                    defaultValue={prize.cost}

                                                                    name='cost'
                                                                    required
                                                                    onChange={(value) => { setEditPrize({ ...editPrize, cost: value.target.value }) }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div class=" mx-auto mt-3 row">
                                                            <Button type="button" className="btn btn-danger shadow col-xs" data-dismiss="modal" onClick={() => deletePrize(prize)}>Delete</Button>
                                                            <Button onClick={() => updatePrize(prize)} type="button" className="btn btn-warning shadow col-xs mx-1 my-3">Save</Button>
                                                            <Button variant="secondary" type="button" className="btn-secondary shadow col-xs" data-dismiss="modal">Cancel</Button>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    )


                                })}
                            </div>
                        </Container>
                    </AnimateHeight>
                    <Container className="mt-4" >
                        <div style={{ position: 'relative', textAlign: 'center' }}>
                            <h3 id="myTransactions" style={{ fontWeight: 800, color: '#0f172a', margin: 0 }}>Transaction History</h3>
                            <Button
                                size="sm"
                                onClick={() => { transHeight === 0 ? setTransHeight("auto") : setTransHeight(0) }}
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    minWidth: (typeof window !== 'undefined' && window.innerWidth < 576) ? 30 : 98,
                                    padding: (typeof window !== 'undefined' && window.innerWidth < 576) ? '0 2px' : '4px 8px',
                                    borderRadius: 999,
                                    border: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : '1px solid #93c5fd',
                                    background: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'transparent' : '#eff6ff',
                                    boxShadow: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : undefined,
                                    color: '#1d4ed8',
                                    fontWeight: 700,
                                    fontSize: 12,
                                }}
                            >
                                <span className="d-inline d-sm-none" style={{ fontSize: 24, fontWeight: 800, lineHeight: 1 }}>{transHeight === 0 ? '+' : '-'}</span>
                                <span className="d-none d-sm-inline">{transHeight === 0 ? 'Expand' : 'Collapse'}</span>
                            </Button>
                        </div>
                        <hr style={{ borderTop: '1px solid #bfdbfe' }} />
                        <p className="text-center font-italic" style={{ color: '#334155' }}>View transaction history</p>
                    </Container>
                    <AnimateHeight
                        id='example-panel'
                        aria-hidden="false"
                        duration={500}
                        height={transHeight} // see props documentation below
                    >
                        <Container className=" text-center mt-2 borderRound shadow limitHeightSmall" >
                            <PaginatedItems itemsPerPage={5} />
                        </Container>
                    </AnimateHeight>
                    <Container className="mt-4" >
                        <div style={{ position: 'relative', textAlign: 'center' }}>
                            <h3 id="myPurchases" style={{ fontWeight: 800, color: '#0f172a', margin: 0 }}>Purchase History</h3>
                            <Button
                                size="sm"
                                onClick={() => { historyHeight === 0 ? setHistoryHeight("auto") : setHistoryHeight(0) }}
                                style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    minWidth: (typeof window !== 'undefined' && window.innerWidth < 576) ? 30 : 98,
                                    padding: (typeof window !== 'undefined' && window.innerWidth < 576) ? '0 2px' : '4px 8px',
                                    borderRadius: 999,
                                    border: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : '1px solid #93c5fd',
                                    background: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'transparent' : '#eff6ff',
                                    boxShadow: (typeof window !== 'undefined' && window.innerWidth < 576) ? 'none' : undefined,
                                    color: '#1d4ed8',
                                    fontWeight: 700,
                                    fontSize: 12,
                                }}
                            >
                                <span className="d-inline d-sm-none" style={{ fontSize: 24, fontWeight: 800, lineHeight: 1 }}>{historyHeight === 0 ? '+' : '-'}</span>
                                <span className="d-none d-sm-inline">{historyHeight === 0 ? 'Expand' : 'Collapse'}</span>
                            </Button>
                        </div>
                        <hr style={{ borderTop: '1px solid #bfdbfe' }} />
                        <p className="text-center font-italic" style={{ color: '#334155' }}>View purchases from current users</p>
                    </Container>
                    <AnimateHeight
                        id='example-panel'
                        aria-hidden="false"
                        duration={500}
                        height={historyHeight} // see props documentation below
                    >
                        <Container className=" text-center mt-2 borderRound shadow limitHeightSmall mb-5" >
                            {purchaseHistory()}
                        </Container>
                    </AnimateHeight>
                    <div id='footer' className="border mt-5">
                        <div className='container text-center'>
                            <p>
                                &copy; 2022 Crew Coin. All Rights Reserved.
                            </p>
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                                {user?.admin ? (
                                    <Button
                                        className="py-1 shadow"
                                        size="sm"
                                        onClick={resendSignupPoster}
                                        disabled={resendingPoster}
                                        style={{
                                            background: 'linear-gradient(135deg, #f59e0b, #f97316)',
                                            border: 'none',
                                            borderRadius: 10,
                                            color: '#fff',
                                            fontWeight: 700,
                                            letterSpacing: 0.2,
                                            padding: '8px 14px',
                                        }}
                                    >
                                        {resendingPoster ? 'Sending...' : 'Resend Sign-Up Poster'}
                                    </Button>
                                ) : null}
                                <FAQWidget
                                    hideFloating
                                    buttonClassName="btn btn-sm py-1 shadow"
                                    buttonStyle={{
                                        background: 'linear-gradient(135deg, #06b6d4, #0ea5e9)',
                                        border: 'none',
                                        borderRadius: 10,
                                        color: '#fff',
                                        fontWeight: 700,
                                        letterSpacing: 0.2,
                                        padding: '8px 14px',
                                    }}
                                />
                            </div>
                            <button
                                onClick={openBillingPortal}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    color: '#6b7280',
                                    fontSize: 12,
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }}
                            >
                                Cancel subscription
                            </button>
                        </div>
                    </div>
                    {showPosterEmailModal ? (
                        <div
                            onClick={() => !resendingPoster && setShowPosterEmailModal(false)}
                            style={{
                                position: 'fixed',
                                inset: 0,
                                background: 'rgba(15,23,42,0.55)',
                                zIndex: 99999,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                padding: 16,
                            }}
                        >
                            <div
                                onClick={(e) => e.stopPropagation()}
                                style={{ background: '#fff', width: '100%', maxWidth: 460, borderRadius: 12, boxShadow: '0 20px 50px rgba(0,0,0,.25)' }}
                            >
                                <div style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: 800 }}>Resend Sign-Up Poster</div>
                                <div style={{ padding: 16 }}>
                                    <Form.Group>
                                        <Form.Label>Email address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            value={posterEmail}
                                            onChange={(e) => setPosterEmail(e.target.value)}
                                            placeholder="name@company.com"
                                            autoFocus
                                        />
                                    </Form.Group>
                                </div>
                                <div style={{ padding: 16, borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                    <Button variant="secondary" onClick={() => setShowPosterEmailModal(false)} disabled={resendingPoster}>Cancel</Button>
                                    <Button onClick={submitResendSignupPoster} disabled={resendingPoster} style={{ background: 'linear-gradient(135deg, #f59e0b, #f97316)', border: 'none', color: '#fff', fontWeight: 700 }}>
                                        {resendingPoster ? 'Sending...' : 'Send Poster'}
                                    </Button>
                                </div>
                            </div>
                        </div>
                    ) : null}
                    </div>
                </div>
            </div>
        );
    }
    else {
        return (
            <div>
                <style>{`@keyframes slideInRight { from { transform: translateX(100%); opacity: 0.8; } to { transform: translateX(0); opacity: 1; } } @keyframes slideOutRight { from { transform: translateX(0); opacity: 1; } to { transform: translateX(100%); opacity: 0.8; } } @keyframes fadeInFast { from { opacity: 0; } to { opacity: 1; } } @keyframes fadeOutFast { from { opacity: 1; } to { opacity: 0; } }`}</style>
                <nav id='menu' className='navbar navbar-default navbar-fixed-top'>
                    <div className='container'>
                        <div className='navbar-header'>
                            <button
                                type='button'
                                className='navbar-toggle collapsed'
                                data-toggle='collapse'
                                data-target='#bs-example-navbar-collapse-1'
                            >
                                {' '}
                                <span className='sr-only'>Toggle navigation</span>{' '}
                                <span className='icon-bar'></span>{' '}
                                <span className='icon-bar'></span>{' '}
                                <span className='icon-bar'></span>{' '}
                            </button>
                            <button
                                type='button'
                                className='navbar-toggle'
                                onClick={() => setShowProfilePanel(true)}
                                aria-label='Edit profile'
                                style={{ marginRight: 8, border: 'none', background: 'transparent', color: '#333' }}
                            >
                                <FontAwesomeIcon icon={faCircleUser} size="lg" />
                            </button>
                        </div>

                        <div
                            className='collapse navbar-collapse'
                            id='bs-example-navbar-collapse-1'
                        >
                            <ul className='nav navbar-nav navbar-left'>

                                <li>
                                    <img alt="crewcoinlogo" className="crewcoinSm" src={'../img/crewcoinlogo.png'} />
                                </li>
                                <li>

                                </li>
                            </ul>
                            <ul className='nav navbar-nav navbar-right' style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <li>
                                    <Link to="/">Logout</Link>
                                </li>
                                <li style={{ paddingTop: 10 }}>
                                    <button
                                        type="button"
                                        onClick={() => setShowProfilePanel(true)}
                                        style={{ border: 'none', background: 'transparent', color: '#333' }}
                                        aria-label="Edit profile"
                                    >
                                        <FontAwesomeIcon icon={faCircleUser} size="lg" />
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </nav>
                {showProfilePanel && (
                    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.35)', zIndex: 1200, animation: isClosingProfilePanel ? 'fadeOutFast 200ms ease-in forwards' : 'fadeInFast 200ms ease-out' }} onClick={closeProfilePanel}>
                        <div style={{ position: 'absolute', right: 0, top: 0, width: 'min(92vw, 360px)', height: '100%', background: '#fff', padding: 20, animation: isClosingProfilePanel ? 'slideOutRight 200ms ease-in forwards' : 'slideInRight 220ms ease-out' }} onClick={(e) => e.stopPropagation()}>
                            <h4 style={{ marginTop: 0 }}>Edit Profile</h4>
                            <Form.Group className="mb-3"><Form.Label>First Name</Form.Label><Form.Control value={profileForm.firstname} onChange={(e) => setProfileForm({ ...profileForm, firstname: e.target.value })} /></Form.Group>
                            <Form.Group className="mb-3"><Form.Label>Last Name</Form.Label><Form.Control value={profileForm.lastname} onChange={(e) => setProfileForm({ ...profileForm, lastname: e.target.value })} /></Form.Group>
                            <Form.Group className="mb-3"><Form.Label>Phone</Form.Label><Form.Control value={profileForm.phone} onChange={(e) => setProfileForm({ ...profileForm, phone: e.target.value })} /></Form.Group>
                            {user?.admin && <Form.Group className="mb-3"><Form.Label>Organization Name</Form.Label><Form.Control value={profileForm.organization} onChange={(e) => setProfileForm({ ...profileForm, organization: e.target.value })} /></Form.Group>}
                            <Form.Group className="mb-3"><Form.Label>Email</Form.Label><Form.Control value={user?.username || ''} disabled /></Form.Group>
                            <div style={{ display: 'flex', gap: 8 }}>
                                <Button variant="secondary" onClick={closeProfilePanel}>Cancel</Button>
                                <Button onClick={saveProfile} disabled={profileSaving}>{profileSaving ? 'Saving...' : 'Save'}</Button>
                            </div>
                        </div>
                    </div>
                )}
                <Container className="mt-5 pt-5" >
                    <div className='col-sm-8 col-sm-offset-2 text-center mt-5'>
                        <h1 className="">{user.firstname}, Welcome  to your Dashboard!</h1>
                    </div>
                </Container>
                <Container className="mt-2 pt-2" >
                    <div className='col-sm-8 col-sm-offset-2 text-center mt-5'>
                        <Card className="">
                            <Card.Body>
                                <Card.Title>
                                    <h2>{user.organization} </h2>
                                </Card.Title>
                                <Card.Text>
                                    <h4>PortalId: {user.portalId}</h4>
                                    <h4>Balance: {user.balance}</h4>
                                </Card.Text>
                            </Card.Body>
                        </Card>
                    </div>
                </Container>
                {renderBadgesSection()}
                {renderEarnSection()}

                <Container className="mt-5 pt-5" >
                    <div className='col-sm-12 text-center mt-5 pb-5 limitHeight shadow borderRound'>
                        <h3>My Transaction History</h3>
                        <hr />
                        <p>View your transaction history</p>

                        <PaginatedItems itemsPerPage={10} />

                    </div>
                </Container>
                <div id='footer' className="border mt-5">
                    <div className='container text-center'>
                        <p>
                            &copy; 2022 Crew Coin. All Rights Reserved.
                        </p>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 10, flexWrap: 'wrap', marginBottom: 8 }}>
                            {user?.admin ? (
                                <Button
                                    className="py-1 shadow"
                                    size="sm"
                                    onClick={resendSignupPoster}
                                    disabled={resendingPoster}
                                    style={{
                                        background: 'linear-gradient(135deg, #f59e0b, #f97316)',
                                        border: 'none',
                                        borderRadius: 10,
                                        color: '#fff',
                                        fontWeight: 700,
                                        letterSpacing: 0.2,
                                        padding: '8px 14px',
                                    }}
                                >
                                    {resendingPoster ? 'Sending...' : 'Resend Sign-Up Poster'}
                                </Button>
                            ) : null}
                            <FAQWidget
                                hideFloating
                                buttonClassName="btn btn-sm py-1 shadow"
                                buttonStyle={{
                                    background: 'linear-gradient(135deg, #06b6d4, #0ea5e9)',
                                    border: 'none',
                                    borderRadius: 10,
                                    color: '#fff',
                                    fontWeight: 700,
                                    letterSpacing: 0.2,
                                    padding: '8px 14px',
                                }}
                            />
                        </div>
                        <button
                            onClick={openBillingPortal}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                color: '#6b7280',
                                fontSize: 12,
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            }}
                        >
                            Cancel subscription
                        </button>
                    </div>
                </div>
                {showPosterEmailModal ? (
                    <div
                        onClick={() => !resendingPoster && setShowPosterEmailModal(false)}
                        style={{
                            position: 'fixed',
                            inset: 0,
                            background: 'rgba(15,23,42,0.55)',
                            zIndex: 99999,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: 16,
                        }}
                    >
                        <div
                            onClick={(e) => e.stopPropagation()}
                            style={{ background: '#fff', width: '100%', maxWidth: 460, borderRadius: 12, boxShadow: '0 20px 50px rgba(0,0,0,.25)' }}
                        >
                            <div style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb', fontWeight: 800 }}>Resend Sign-Up Poster</div>
                            <div style={{ padding: 16 }}>
                                <Form.Group>
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        value={posterEmail}
                                        onChange={(e) => setPosterEmail(e.target.value)}
                                        placeholder="name@company.com"
                                        autoFocus
                                    />
                                </Form.Group>
                            </div>
                            <div style={{ padding: 16, borderTop: '1px solid #e5e7eb', display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                <Button variant="secondary" onClick={() => setShowPosterEmailModal(false)} disabled={resendingPoster}>Cancel</Button>
                                <Button onClick={submitResendSignupPoster} disabled={resendingPoster} style={{ background: 'linear-gradient(135deg, #f59e0b, #f97316)', border: 'none', color: '#fff', fontWeight: 700 }}>
                                    {resendingPoster ? 'Sending...' : 'Send Poster'}
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>

        )
    }
}

